import { LoggedUser } from '../authentication/authentication';

// not needed to check all keys
export function isClient(checkedObj: unknown): LoggedUser | null {
  if(
    !!checkedObj &&
    typeof checkedObj === 'object' &&
    'clientAccountId' in checkedObj &&
    typeof checkedObj.clientAccountId === 'number'
  ) {
    return checkedObj as LoggedUser;
  }
  return null;
}